import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-20 w-full rounded-md border-4 border-black dark:border-white bg-white dark:bg-gray-900 px-4 py-3 text-base font-bold text-black dark:text-white placeholder:text-black/60 dark:placeholder:text-white/60 transition-all duration-200 outline-none",
        "focus:bg-[#facc15] focus:border-8 focus:border-black dark:focus:border-white",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
